module.exports = __webpack_public_path__ + "img/21_46.e65af558.png";